const leaflets = {
  "procasa": {
    "config": {
      "primary-color": "rgb(46, 163, 80)",
      "secondary-color": "rgb(133, 37, 54)",
      "tertiary-color": "rgb(255, 255, 255)",
      "hover-color": "rgba(220, 35, 17, 0.5)",
      "primary-alpha-color": "rgba(35, 94, 157, 0.7)",
      "clientIcon": require("assets/images/clientLogo_procasa.png"),
      "serverPath": "procasa.volantinointerattivo.net/",
      "pdfPath": "/media/pdf/volantino.pdf",
      "shareFlyerTitle": "Dai uno sguardo ai prodotti e le offerte di Procasa!",
      "shareFlyerURL": "https://procasa.volantinointerattivo.net?v=204",
      "shareProductSentence": "Guarda questa fantastica offerta!",
      "ogTitleMeta": "Prodotti e offerte di Procasa",
      "ogDescriptionMeta": "Dai uno sguardo alle nostre nuove offerte.",
      "ogImageMeta": "https://procasa.volantinointerattivo.net/media/images/procasa_natale_fb.png",
      "filterBrand": 0,
      "filterUnderprice": 0,
      "brandImage": "",
      "underPriceImage": "",
      "ga_active": true,
      "ga_tracking_id": "UA-152069090-3",
      "release_id": "1",
      "send_grocery_list_to_market": false,
      "grocery_list_min_value": 20,
      "client_id": 4,
      "signboard_id": 4,
      "has_pages": true,
      "hide_grocery_list": false,
      "hide_searchbar": false,
      "line_through": false,
      "category_banner": "",
      "category_banner_mobile": "",
      "hide_plus_product": false,
      "hide_plus_product_price": false,
      "type": "leaflet",
      "product_banner": "",
      "href_banner": "",
      "internal_banner_click": false,
      "external_banner_click": false
    },
    "leaflet": {
      "name": "Pro casa Natale 2020",
      "code": "204",
      "id_campaign": "204",
      "index": {
        "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/pages/indice-procasa-natale_sFFsQ4P.png",
        "links": [
          {
            "page": 2,
            "blueprint": {
              "top": 31.456551974621767,
              "left": 10.61883732644301,
              "width": 77.59019852001668,
              "height": 5.694752122653537
            }
          },
          {
            "page": 3,
            "blueprint": {
              "top": 40.24823244142351,
              "left": 10.298232436081024,
              "width": 77.59019852001668,
              "height": 5.694752122653537
            }
          },
          {
            "page": 4,
            "blueprint": {
              "top": 49.09908098737634,
              "left": 10.61883732644301,
              "width": 77.59019852001668,
              "height": 5.694752122653537
            }
          },
          {
            "page": -1,
            "type": "url",
            "url": "https://volantinointerattivo.net",
            "target": "_Blank",
            "blueprint": {
              "top": 6.2069042798765865,
              "left": 54.74418604651163,
              "width": 37.32928118393235,
              "height": 7.142216810225684
            }
          }
        ]
      },
      "categories": [
        {
          "category_name": "Addobbi",
          "subcategories": [
            "Alberi di Natale",
            "Decorazioni",
            "Natività",
            "Idee regalo",
            "Per la tavola",
            "Accessori",
            "Illuminazione"
          ]
        },
        {
          "category_name": "Casa e Cucina",
          "subcategories": [
            "Altro"
          ]
        }
      ],
      "pages": [
        {
          "number": 1,
          "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/pages/page_1_zQIGE7a.jpg",
          "products": [
            {
              "item_id": "196625",
              "field1": "ALBERO DI NATALE ",
              "field2": "MOD. ALASKA",
              "field3": "DISPONIBILE H 150,180,210,240 CM",
              "field4": "A PARTIRE DA N. 734 RAMI ",
              "description": "ALBERO DI NATALE  MOD. ALASKA DISPONIBILE H 150,180,210,240 CM A PARTIRE DA N. 734 RAMI ",
              "grammage": null,
              "price": "74.90",
              "price_label": "€ 74,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Alberi di Natale",
              "blueprint": {
                "top": 48.925756833113965,
                "left": 2.751713395638627,
                "width": 22.598753894081,
                "height": 44.111103156201985
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/16853_1572952346.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_zRUozDz_KWz0pFp.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "info",
                  "title": "",
                  "data": {
                    "titolo": "La decorazione degli alberi di Natale è iniziata con Martin Lutero",
                    "testo": "Martin Lutero, il protestante del XVI secolo, è considerato come la prima persona ad aver aggiunto delle candele ad un albero. Mentre tornava a casa in una notte d’inverno, fu affascinato dalla luminosità delle stelle che brillavano tra i sempreverdi, secondo History.com. Ricreò tale vista per la sua famiglia erigendo un albero nella sala principale della casa e adornò i rami con delle candele accese. “Lutero ha suggerito di porre delle candele sui rami, che è poi diventata una pratica abbastanza popolare fino all’invenzione delle lucine elettriche”, ha spiegato Cass. L’idea di mettere luci elettriche sugli alberi di Natale venne in mente ad Edward Johnson, assistente di Thomas Edison, nel 1882, secondo l’University of Illinois. (Fonte: http://www.meteoweb.eu)",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/UddhfhZpvX/images/albero.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "238126",
              "field1": "PALLINA NATALIZIA IN VELLUTO ",
              "field2": "DIMENSIONI: DIAM 10 CM",
              "field3": "ASSORTITA IN 4 COLORI ",
              "field4": "",
              "description": "PALLINA NATALIZIA IN VELLUTO  DIMENSIONI: DIAM 10 CM ASSORTITA IN 4 COLORI ",
              "grammage": null,
              "price": "1.95",
              "price_label": "€ 1,95",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Decorazioni",
              "blueprint": {
                "top": 48.7388409452635,
                "left": 26.541433021806856,
                "width": 23.259579439252338,
                "height": 14.391476987977684
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/64730b_1604684476.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_bKoUgb4_PfJOYWj.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "237316",
              "field1": "NATIVITA' IN TESSUTO CON BASE",
              "field2": "MOD. LORD ",
              "field3": "DIMENSIONI: CM 22H",
              "field4": "COLORI: AVORIO E NOCCIOLA",
              "description": "NATIVITA' IN TESSUTO CON BASE MOD. LORD  DIMENSIONI: CM 22H COLORI: AVORIO E NOCCIOLA",
              "grammage": null,
              "price": "24.90",
              "price_label": "€ 24,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Natività",
              "blueprint": {
                "top": 48.645383001338274,
                "left": 50.46183800623054,
                "width": 47.0522585669782,
                "height": 14.391476987977684
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/676220_1604142486.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_D1sKH7c_AxmxZnb.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "info",
                  "title": "",
                  "data": {
                    "titolo": "Etimologia del termine “Presepe“",
                    "testo": "Cominciamo dalla parola “presepe“, una parola curiosa, sul significato della quale è lecito interrogarsi. Ebbene, la parola “presepe” deriva dal latino “praesepe“, che significa semplicemente “mangiatoia”. Quindi quella che sarebbe stata la culla improvvisata del piccolo Gesù ha finito col dare nome a tutta la scenografia che ogni anno ci ricorda il miracolo della sua nascita! Anche le parole che definiscono il presepe nelle altre lingue derivano da un termine che in basso latino significava mangiatoia: “cripia”. Ecco quindi “crechè”, “crib”, “krippe”, “krubba”, ovvero “presepe” in francese, inglese, tedesco e svedese. Le parole “szopka” in polacco e “wertep” in russo significano sempre mangiatoia e vengono usate per definire il presepe. (Fonte: www.holyart.it)",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/UddhfhZpvX/images/presepe.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "237315",
              "field1": "SOLDATINO SCHIACCIANOCI NATALIZIO",
              "field2": "DIMENSIONI: CM 13X9X51H   ",
              "field3": "ASSORTITO IN 2 MODELLI",
              "field4": "",
              "description": "SOLDATINO SCHIACCIANOCI NATALIZIO DIMENSIONI: CM 13X9X51H    ASSORTITO IN 2 MODELLI",
              "grammage": null,
              "price": "18.50",
              "price_label": "€ 18,50",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Idee regalo",
              "blueprint": {
                "top": 63.78556991722612,
                "left": 26.53995327102804,
                "width": 23.26253894080998,
                "height": 14.391476987977684
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/65056_1604142356.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_kMdn3uP_bYLqfPd.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "237317",
              "field1": "PUPAZZO DI NEVE LUMINOSO",
              "field2": "DIMENSIONI: CM 32,5H          ",
              "field3": "ASSORTITO IN 3 MODELLI",
              "field4": "",
              "description": "PUPAZZO DI NEVE LUMINOSO DIMENSIONI: CM 32,5H           ASSORTITO IN 3 MODELLI",
              "grammage": null,
              "price": "39.90",
              "price_label": "€ 39,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Decorazioni",
              "blueprint": {
                "top": 63.59865402937565,
                "left": 50.46183800623054,
                "width": 23.26253894080998,
                "height": 14.484934931902917
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/662385_1604142613.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_iMv7kFY_wck91xZ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "237649",
              "field1": "VILLAGGIO NATALIZIO CON MUSICA E LUCI ",
              "field2": "TRENINO IN MOVIMENTO",
              "field3": "DIMENSIONI: CM 20X14 ",
              "field4": "",
              "description": "VILLAGGIO NATALIZIO CON MUSICA E LUCI  TRENINO IN MOVIMENTO DIMENSIONI: CM 20X14 ",
              "grammage": null,
              "price": "27.90",
              "price_label": "€ 27,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Decorazioni",
              "blueprint": {
                "top": 63.59865402937565,
                "left": 74.49065420560747,
                "width": 23.130373831775714,
                "height": 14.484934931902917
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/2197042_1604400543.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_bSfFw9Z_QzXOoXW.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "info",
                  "title": "VILLAGGIO NATALIZIO CON MUSICA E LUCI PUPAZZO",
                  "data": {
                    "titolo": "VILLAGGIO NATALIZIO CON MUSICA E LUCI PUPAZZO",
                    "testo": "VILLAGGIO NATALIZIO CON MUSICA E LUCI PUPAZZO 20X14.5X17CM Villaggio natalizio In plastica Con casetta Quattro personaggi con pupazzo di neve Paesaggio innevato con alberi e ruscello Con luci e carillon Interruttore ON/OFF Funziona con 3 batterie AA (NON INCLUSE) Misure: l. 20 x p. 14.5 x h. 17 cm",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/UddhfhZpvX/images/2197042_1604400543.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "237729",
              "field1": "MACCHINA PER CASCATA DI CIOCCOLATO",
              "field2": "90 WATT",
              "field3": "500 ML",
              "field4": "CON 3 PIANI ",
              "description": "MACCHINA PER CASCATA DI CIOCCOLATO 90 WATT 500 ML CON 3 PIANI ",
              "grammage": null,
              "price": "34.90",
              "price_label": "€ 34,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Idee regalo",
              "blueprint": {
                "top": 78.7388409452635,
                "left": 26.64688473520248,
                "width": 23.130373831775714,
                "height": 14.484934931902917
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/MACCHINACIOCC_1604489636.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_0PKGWXf_TKAIluI.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "info",
                  "title": "Descrizione",
                  "data": {
                    "titolo": "Descrizione",
                    "testo": "Questa fontana di cioccolato Nedis sarà un successo, che tu voglia organizzare una festa, pianificare un tè pomeridiano a casa o sorprendere i tuoi ospiti con un dolcetto dopo cena. Sciogli il tuo cioccolato preferito e versalo nella base della fontana. Ora puoi iniziare a intingere fette di frutta, marshmallow, biscotti o qualsiasi cosa soddisfi i tuoi desideri a base di cioccolato. Questa fontana di cioccolato ha 3 piani con spazio sufficiente tra un livello e l'altro per fragole grandi o fette di dolce. La fontana stessa è rimovibile e le parti sono lavabili in lavastoviglie.",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/UddhfhZpvX/images/MACCHINACIOCC_1604489636.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "237838",
              "field1": "SERVIZIO PIATTI NATALIZIO TOGNANA",
              "field2": "MOD. OLIMPIA SCOZIA      ",
              "field3": "18 PEZZI",
              "field4": "",
              "description": "SERVIZIO PIATTI NATALIZIO TOGNANA MOD. OLIMPIA SCOZIA       18 PEZZI",
              "grammage": null,
              "price": "39.90",
              "price_label": "€ 39,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Per la tavola",
              "blueprint": {
                "top": 78.7388409452635,
                "left": 50.43660436137071,
                "width": 23.130373831775714,
                "height": 14.484934931902917
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/piattinat_1604577128.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_CzIco2F_SNnwDQs.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "237318",
              "field1": "SET NATALIZIO GUANTONE-PRESINA-GREMBIULE",
              "field2": "IN COTONE ",
              "field3": "MOD. DRIA",
              "field4": "ASSORTITO IN 3 COLORI ",
              "description": "SET NATALIZIO GUANTONE-PRESINA-GREMBIULE IN COTONE  MOD. DRIA ASSORTITO IN 3 COLORI ",
              "grammage": null,
              "price": "6.95",
              "price_label": "€ 6,95",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Idee regalo",
              "blueprint": {
                "top": 78.64538300133826,
                "left": 74.35848909657322,
                "width": 23.130373831775714,
                "height": 14.484934931902917
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/62447c_1604142777.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_noAuz3d_AQOuUnH.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 2,
          "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/pages/page_2_vLqtQeJ.jpg",
          "products": [
            {
              "item_id": "237319",
              "field1": "STELLA NATALIZIA CON NASTRO",
              "field2": "DIMENSIONI: DIAM 40,5 CM      ",
              "field3": "",
              "field4": "",
              "description": "STELLA NATALIZIA CON NASTRO DIMENSIONI: DIAM 40,5 CM      ",
              "grammage": null,
              "price": "6.45",
              "price_label": "€ 6,45",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Decorazioni",
              "blueprint": {
                "top": 8.504672897196263,
                "left": 2.6433021806853585,
                "width": 22.97223520249221,
                "height": 20.747663551401875
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/63388_1604142942.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_mWipRmm_msxa3Fk.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "237320",
              "field1": "DECORAZIONE NATALIZIA IN TESSUTO",
              "field2": "DIMENSIONI: CM 30X36H       ",
              "field3": "ASSORTITA IN 4 MODELLI",
              "field4": "",
              "description": "DECORAZIONE NATALIZIA IN TESSUTO DIMENSIONI: CM 30X36H        ASSORTITA IN 4 MODELLI",
              "grammage": null,
              "price": "2.45",
              "price_label": "€ 2,45",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Decorazioni",
              "blueprint": {
                "top": 8.411214953271028,
                "left": 26.565186915887857,
                "width": 22.97223520249221,
                "height": 20.654205607476637
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/64248_1604143010.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_uoOilEi_kJEYeTO.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "info",
                  "title": "DECORAZIONE TESSUTO ",
                  "data": {
                    "titolo": "DECORAZIONE TESSUTO ",
                    "testo": "DECORAZIONE TESSUTO A4M NAT CM30X36 -Decorazione natalizia in tessuto -Da appendere -Assortita in 4 modelli: renna, babbo, folletto, albero di Natale -Dimensioni: cm 30x36.\n",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/UddhfhZpvX/images/64248_1604143010.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "237325",
              "field1": "SFERA NATALIZIA IN VETRO ",
              "field2": "MOD. DELIGHT ",
              "field3": "ASSORTITA IN 3 MODELLI",
              "field4": "",
              "description": "SFERA NATALIZIA IN VETRO  MOD. DELIGHT  ASSORTITA IN 3 MODELLI",
              "grammage": null,
              "price": "2.85",
              "price_label": "€ 2,85",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Decorazioni",
              "blueprint": {
                "top": 8.504672897196263,
                "left": 50.22274143302182,
                "width": 22.97223520249221,
                "height": 20.654205607476637
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/342051_1604145023.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_nFXc2NO_0wyCepP.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "237324",
              "field1": "CALZA NATALIZIA IN TESSUTO                  ",
              "field2": "DIMENSIONI: CM 19X30H                                               ",
              "field3": "",
              "field4": "",
              "description": "CALZA NATALIZIA IN TESSUTO                   DIMENSIONI: CM 19X30H                                               ",
              "grammage": null,
              "price": "1.85",
              "price_label": "€ 1,85",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Accessori",
              "blueprint": {
                "top": 29.719626168224305,
                "left": 2.6433021806853585,
                "width": 22.97223520249221,
                "height": 20.654205607476637
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/64246b_1604144351.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_2cZBqVl_H0iNdU8.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "237323",
              "field1": "BABBO NATALE ",
              "field2": "CON SLITTA E 12 LED   ",
              "field3": "COLORE: ROSSO E BIANCO",
              "field4": "",
              "description": "BABBO NATALE  CON SLITTA E 12 LED    COLORE: ROSSO E BIANCO",
              "grammage": null,
              "price": "39.90",
              "price_label": "€ 39,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Decorazioni",
              "blueprint": {
                "top": 29.719626168224305,
                "left": 26.697352024922125,
                "width": 22.97223520249221,
                "height": 20.654205607476637
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/2124112_1604144241.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_89FvTTZ_YqmHLHA.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "237438",
              "field1": "PALLINA DI NATALE ",
              "field2": "DIMENSIONI: DIAM 13 CM   ",
              "field3": "ASSORTITA IN 3 DECORAZIONI",
              "field4": "",
              "description": "PALLINA DI NATALE  DIMENSIONI: DIAM 13 CM    ASSORTITA IN 3 DECORAZIONI",
              "grammage": null,
              "price": "3.45",
              "price_label": "€ 3,45",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Decorazioni",
              "blueprint": {
                "top": 30.09345794392524,
                "left": 50.354906542056085,
                "width": 22.97223520249221,
                "height": 20.37383177570094
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/62966c_1604316798.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_onWIa85_TH4GPIy.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "info",
                  "title": "PALLINA DI NATALE",
                  "data": {
                    "titolo": "PALLINA DI NATALE",
                    "testo": "PALLINA NATALE ASS3DEC DIAM13 -Pallina di Natale decorata -Assortita in 3 decorazioni da poter richiedere -Dimensioni: diam 13cm.\n",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/UddhfhZpvX/images/62966c_1604316798.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "238084",
              "field1": "ALBERO DI NATALE ",
              "field2": "MOD. ALPINO ",
              "field3": "DISPONIBILI H150,180,210,240 CM ",
              "field4": "A PARTIRE DA N. 663 RAMI",
              "description": "ALBERO DI NATALE  MOD. ALPINO  DISPONIBILI H150,180,210,240 CM  A PARTIRE DA N. 663 RAMI",
              "grammage": null,
              "price": "49.90",
              "price_label": "€ 49,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Alberi di Natale",
              "blueprint": {
                "top": 8.598130841121497,
                "left": 74.27679127725858,
                "width": 22.97223520249221,
                "height": 41.77570093457945
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/16851_1604663517.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_yrqKAD4_nSDuX8H.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "237322",
              "field1": "RENNA IN CERAMICA                                   ",
              "field2": "DIMENSIONI:  CM 10X6X16H                                             ",
              "field3": "ASSORTITA IN 3 COLORI ",
              "field4": "",
              "description": "RENNA IN CERAMICA                                    DIMENSIONI:  CM 10X6X16H                                              ASSORTITA IN 3 COLORI ",
              "grammage": null,
              "price": "2.95",
              "price_label": "€ 2,95",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Decorazioni",
              "blueprint": {
                "top": 51.308411214953274,
                "left": 2.6433021806853585,
                "width": 22.97223520249221,
                "height": 20.5607476635514
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/620241_1604143419.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_XE6CGyn_tXryPzZ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "237669",
              "field1": "NATIVITA' IN TESSUTO ",
              "field2": "AVORIO E ORO",
              "field3": "DIMENSIONI: CM 38H",
              "field4": "",
              "description": "NATIVITA' IN TESSUTO  AVORIO E ORO DIMENSIONI: CM 38H",
              "grammage": null,
              "price": "62.90",
              "price_label": "€ 62,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Natività",
              "blueprint": {
                "top": 72.52336448598132,
                "left": 2.775467289719627,
                "width": 22.97223520249221,
                "height": 20.5607476635514
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/682394_1604404194.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_ztDGrE1_zRI9YeK.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "237718",
              "field1": "LANTERNA NATALIZIA CON LED ",
              "field2": "DIMENSIONI: CM 11X11X24H    ",
              "field3": "ASSORTITA IN 3 COLORI ",
              "field4": "",
              "description": "LANTERNA NATALIZIA CON LED  DIMENSIONI: CM 11X11X24H     ASSORTITA IN 3 COLORI ",
              "grammage": null,
              "price": "4.95",
              "price_label": "€ 4,95",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Idee regalo",
              "blueprint": {
                "top": 51.308411214953274,
                "left": 26.565186915887857,
                "width": 22.97223520249221,
                "height": 20.5607476635514
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/64749c_1604423173.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_ge7y6cP_DEI2hTd.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "237321",
              "field1": "SET 6 CANDELE SEGNAPOSTO ",
              "field2": "MOD. PALLINA CON STELLE",
              "field3": "DIMENSIONI: DIAM 4 CM       ",
              "field4": "ASSORTITE IN 4 COLORI ",
              "description": "SET 6 CANDELE SEGNAPOSTO  MOD. PALLINA CON STELLE DIMENSIONI: DIAM 4 CM        ASSORTITE IN 4 COLORI ",
              "grammage": null,
              "price": "3.95",
              "price_label": "€ 3,95",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Per la tavola",
              "blueprint": {
                "top": 72.52336448598132,
                "left": 26.43302180685359,
                "width": 22.97223520249221,
                "height": 20.5607476635514
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/65086c_1604143083.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_X0Qm3n3_x77KtQl.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "237518",
              "field1": "TISANIERA NATALIZIA CON COPERCHIO E FILTRO ",
              "field2": "CAPACITA' 370 ML        ",
              "field3": "ASSORTITA IN 3 MODELLI",
              "field4": "",
              "description": "TISANIERA NATALIZIA CON COPERCHIO E FILTRO  CAPACITA' 370 ML         ASSORTITA IN 3 MODELLI",
              "grammage": null,
              "price": "3.95",
              "price_label": "€ 3,95",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Per la tavola",
              "blueprint": {
                "top": 72.7102803738318,
                "left": 50.354906542056085,
                "width": 22.97223520249221,
                "height": 20.5607476635514
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/63415_1604338521.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_qRh1pQt_N6r9VJ7.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "237747",
              "field1": "PACCO DONO NATALIZIO LUMINOSO ",
              "field2": "CON 20 LED ",
              "field3": "DISPONIBILE IN DIVERSE MISURE  ",
              "field4": "",
              "description": "PACCO DONO NATALIZIO LUMINOSO  CON 20 LED  DISPONIBILE IN DIVERSE MISURE  ",
              "grammage": null,
              "price": "6.95",
              "price_label": "€ 6,95",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Decorazioni",
              "blueprint": {
                "top": 51.12149532710282,
                "left": 50.619236760124615,
                "width": 22.97223520249221,
                "height": 20.5607476635514
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/63756_1604509515.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_1KOunYc_6daRNDo.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "237722",
              "field1": "PORTA CANDELA NATALIZIO IN LEGNO ",
              "field2": "DIMENSIONI: CM 15X15X16H         ",
              "field3": "ASSORTITO IN 2 MODELLI",
              "field4": "",
              "description": "PORTA CANDELA NATALIZIO IN LEGNO  DIMENSIONI: CM 15X15X16H          ASSORTITO IN 2 MODELLI",
              "grammage": null,
              "price": "2.45",
              "price_label": "€ 2,45",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Accessori",
              "blueprint": {
                "top": 51.214953271028065,
                "left": 74.5411214953271,
                "width": 22.97223520249221,
                "height": 20.5607476635514
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/65634_1604425710.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_DStuyqT_VY7cWPo.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "237717",
              "field1": "TOVAGLIETTA COLAZIONE NATALIZIA",
              "field2": "DIMENSIONI: CM 45X35",
              "field3": "DECORAZIONI ASSORTITE",
              "field4": "",
              "description": "TOVAGLIETTA COLAZIONE NATALIZIA DIMENSIONI: CM 45X35 DECORAZIONI ASSORTITE",
              "grammage": null,
              "price": "0.65",
              "price_label": "€ 0,65",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Per la tavola",
              "blueprint": {
                "top": 72.61682242990656,
                "left": 74.5411214953271,
                "width": 22.97223520249221,
                "height": 20.5607476635514
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/56412_1604422778.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_jDQL3hP_iUkkwhv.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 3,
          "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/pages/page_3_US1wufR.jpg",
          "products": [
            {
              "item_id": "196885",
              "field1": "ALBERO INNEVATO",
              "field2": "MOD. MONTEGELATO",
              "field3": "DISPONIBILE: H 150,180,210,240,270 CM ",
              "field4": "",
              "description": "ALBERO INNEVATO MOD. MONTEGELATO DISPONIBILE: H 150,180,210,240,270 CM ",
              "grammage": null,
              "price": "54.90",
              "price_label": "€ 54,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "H 150",
                "H 180",
                "H 210",
                "H 240",
                "H 270"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Alberi di Natale",
              "blueprint": {
                "top": 8.38131797824696,
                "left": 2.3634836852207304,
                "width": 47.77223288547665,
                "height": 20.793346129238643
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/099975_1573061923.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_ykivJvF_v0vWIdL.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "237440",
              "field1": "SFERA IN VETRO ",
              "field2": "CON PINGUINI",
              "field3": "DIMENSIONI: DIAM 8 CM ",
              "field4": "ASSORTITA IN 3 COLORI ",
              "description": "SFERA IN VETRO  CON PINGUINI DIMENSIONI: DIAM 8 CM  ASSORTITA IN 3 COLORI ",
              "grammage": null,
              "price": "3.45",
              "price_label": "€ 3,45",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Grigio",
                "Blu",
                "Azzurro"
              ],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Decorazioni",
              "blueprint": {
                "top": 8.38131797824696,
                "left": 50.135716570697376,
                "width": 23.795638728940073,
                "height": 20.793346129238643
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/680091_1604316959.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_NPdjC5E_wg1hzFz.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "237519",
              "field1": "RENNA NATALIZIA LUMINOSA NEON ",
              "field2": "NEON CON 360 LED ",
              "field3": "DIMENSIONI: CM 65X58H",
              "field4": "ASSORTITA IN 2 COLORI",
              "description": "RENNA NATALIZIA LUMINOSA NEON  NEON CON 360 LED  DIMENSIONI: CM 65X58H ASSORTITA IN 2 COLORI",
              "grammage": null,
              "price": "24.90",
              "price_label": "€ 24,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Illuminazione",
              "blueprint": {
                "top": 8.38131797824696,
                "left": 73.93135529963745,
                "width": 23.886116442738324,
                "height": 20.793346129238643
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/54411_1604338961.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_HEkOMDo_VvoB1eG.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "info",
                  "title": "",
                  "data": {
                    "titolo": "Renna neon",
                    "testo": "RENNA NEON BI 360L A2C 65X58 Renna luminosa da appendere, colore bianco caldo e freddo da poter richiedere, neon, dimensioni: cm 65x58.",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/UddhfhZpvX/images/1.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "237444",
              "field1": "SFERA IN VETRO ",
              "field2": "MOD. AURORA",
              "field3": "DIMENSIONI: DIAM 10 CM",
              "field4": "ASSORTITA IN 2 COLORI ",
              "description": "SFERA IN VETRO  MOD. AURORA DIMENSIONI: DIAM 10 CM ASSORTITA IN 2 COLORI ",
              "grammage": null,
              "price": "3.45",
              "price_label": "€ 3,45",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Rosa",
                "Grigio"
              ],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Decorazioni",
              "blueprint": {
                "top": 29.686500319897632,
                "left": 2.2730059714224793,
                "width": 23.886116442738324,
                "height": 21.049264235444657
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/680096_1604317081.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_uYozu62_WKIsCgK.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "237454",
              "field1": "FOLLETTO NATALIZIO ALLUNGABILE",
              "field2": "DIMENSIONI: CM 18X12X80H    ",
              "field3": "ASSORTITO IN 4 COLORI",
              "field4": "",
              "description": "FOLLETTO NATALIZIO ALLUNGABILE DIMENSIONI: CM 18X12X80H     ASSORTITO IN 4 COLORI",
              "grammage": null,
              "price": "9.95",
              "price_label": "€ 9,95",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Decorazioni",
              "blueprint": {
                "top": 29.686500319897632,
                "left": 26.159122414160805,
                "width": 23.614683301343568,
                "height": 21.049264235444657
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/63149_1604317971.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_A1CGbcd_dp0Yqqt.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "237719",
              "field1": "DECORAZIONE BABBO NATALE BIANCO",
              "field2": "DIMENSIONI: CM 45H",
              "field3": "",
              "field4": "",
              "description": "DECORAZIONE BABBO NATALE BIANCO DIMENSIONI: CM 45H",
              "grammage": null,
              "price": "19.95",
              "price_label": "€ 19,95",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Decorazioni",
              "blueprint": {
                "top": 29.686500319897632,
                "left": 49.954761143100875,
                "width": 23.976594156536574,
                "height": 21.049264235444657
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/64056_1604423738.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_C5qYYQm_z8FKJeY.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "238010",
              "field1": "PUNTALE NATALIZIO PER ALBERO",
              "field2": "MOD. STELLA GLITTER CM. 25,5 AR  ",
              "field3": "DIMENSIONI:  CM. 25,5H",
              "field4": "COLORI: ARGENTO E ORO",
              "description": "PUNTALE NATALIZIO PER ALBERO MOD. STELLA GLITTER CM. 25,5 AR   DIMENSIONI:  CM. 25,5H COLORI: ARGENTO E ORO",
              "grammage": null,
              "price": "3.95",
              "price_label": "€ 3,95",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Argento",
                "Oro"
              ],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Decorazioni",
              "blueprint": {
                "top": 29.686500319897632,
                "left": 73.93135529963745,
                "width": 23.976594156536574,
                "height": 21.049264235444657
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/669175_1604600082.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_DjK5xTp_RxStdCO.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "237720",
              "field1": "FATINA NATALIZIA LUMINOSA",
              "field2": "CON LED",
              "field3": "DIMENSIONI: CM 19X8X50H ",
              "field4": "ASSORTITA IN 2 COLORI",
              "description": "FATINA NATALIZIA LUMINOSA CON LED DIMENSIONI: CM 19X8X50H  ASSORTITA IN 2 COLORI",
              "grammage": null,
              "price": "8.45",
              "price_label": "€ 8,45",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Illuminazione",
              "blueprint": {
                "top": 50.9916826615483,
                "left": 2.0920505438259767,
                "width": 23.976594156536574,
                "height": 21.049264235444657
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/63834_1604423987.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_GmCTeDy_ddcBoHK.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "237364",
              "field1": "BIMBO NATALIZIO CON LED IN MAGNESIA ",
              "field2": "IN MAGNESIA                                  ",
              "field3": "DIMENSIONI: CM 41H                                              ",
              "field4": "",
              "description": "BIMBO NATALIZIO CON LED IN MAGNESIA  IN MAGNESIA                                   DIMENSIONI: CM 41H                                              ",
              "grammage": null,
              "price": "29.90",
              "price_label": "€ 29,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Accessori",
              "blueprint": {
                "top": 50.9916826615483,
                "left": 26.249600127959056,
                "width": 23.705161015141822,
                "height": 21.049264235444657
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/61992_1604313268.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_HmUUnOh_xSCLT7A.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "238129",
              "field1": "ANGELO NATALIZIO IN TESSUTO14X9X22    ",
              "field2": "DIMENSIONI: CM 14X9X22H",
              "field3": "ASSORTITO IN 2 MODELLI",
              "field4": "",
              "description": "ANGELO NATALIZIO IN TESSUTO14X9X22     DIMENSIONI: CM 14X9X22H ASSORTITO IN 2 MODELLI",
              "grammage": null,
              "price": "6.45",
              "price_label": "€ 6,45",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Accessori",
              "blueprint": {
                "top": 50.9916826615483,
                "left": 49.954761143100875,
                "width": 23.795638728940073,
                "height": 21.049264235444657
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/62103_1604685088.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_T3Jeidi_qPdOsVb.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "237749",
              "field1": "CANDELA NATALIZIA DECORATA ",
              "field2": "MODELLO ALBERO",
              "field3": "DIMENSIONI: DIAM 6X15H CM           ",
              "field4": "COLORI ASSORTITI",
              "description": "CANDELA NATALIZIA DECORATA  MODELLO ALBERO DIMENSIONI: DIAM 6X15H CM            COLORI ASSORTITI",
              "grammage": null,
              "price": "2.25",
              "price_label": "€ 2,25",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Oro",
                "Argento",
                "Beige"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Accessori",
              "blueprint": {
                "top": 50.9916826615483,
                "left": 73.75039987204094,
                "width": 23.976594156536578,
                "height": 21.049264235444657
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/65088d_1604510256.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_2AkcIt2_4jsyXRT.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "237670",
              "field1": "NATIVITÀ IN TESSUTO ",
              "field2": "CON BASE IN PAGLIA",
              "field3": "MOD. LORD",
              "field4": "",
              "description": "NATIVITÀ IN TESSUTO  CON BASE IN PAGLIA MOD. LORD",
              "grammage": null,
              "price": "69.90",
              "price_label": "€ 69,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Natività",
              "blueprint": {
                "top": 72.42482405630199,
                "left": 2.2730059714224793,
                "width": 23.795638728940073,
                "height": 21.049264235444657
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/681245_1604404324.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_5Af5x9Q_3LufdA8.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "info",
                  "title": "",
                  "data": {
                    "titolo": "Natività lord",
                    "testo": "Natività in tessuto lavorato -Con base in legno e paglia -Colore avorio e rosa",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/UddhfhZpvX/images/1_dk7ynzI.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "237661",
              "field1": "ANGELO IN TESSUTO LAVORATO ",
              "field2": "CON FLAUTO ",
              "field3": "DIMENSIONI: CM 50H",
              "field4": "",
              "description": "ANGELO IN TESSUTO LAVORATO  CON FLAUTO  DIMENSIONI: CM 50H",
              "grammage": null,
              "price": "39.90",
              "price_label": "€ 39,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Accessori",
              "blueprint": {
                "top": 72.42482405630199,
                "left": 26.06864470036255,
                "width": 23.886116442738324,
                "height": 21.049264235444657
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/681072_1604402743.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_bpzyeQO_qouWZCL.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "237730",
              "field1": "TAGLIERE NATALIZIO TOGNANA",
              "field2": "CON CIOTOLA E COLTELLO",
              "field3": "PER SALUMI,FORMAGGI E CONFETTURE",
              "field4": "",
              "description": "TAGLIERE NATALIZIO TOGNANA CON CIOTOLA E COLTELLO PER SALUMI,FORMAGGI E CONFETTURE",
              "grammage": null,
              "price": "9.95",
              "price_label": "€ 9,95",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Casa e Cucina",
              "subcategory": "Altro",
              "blueprint": {
                "top": 72.42482405630199,
                "left": 49.954761143100875,
                "width": 23.886116442738324,
                "height": 21.049264235444657
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/ALBEROMIELE_1604490027.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_ZHwUwqb_ChsyO9V.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "237731",
              "field1": "SET 6 CALICI IN VETRO ",
              "field2": "CON GAMBO COLORATO",
              "field3": "MOD. JAZZ",
              "field4": "300 ML      ",
              "description": "SET 6 CALICI IN VETRO  CON GAMBO COLORATO MOD. JAZZ 300 ML      ",
              "grammage": null,
              "price": "6.90",
              "price_label": "€ 6,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Casa e Cucina",
              "subcategory": "Altro",
              "blueprint": {
                "top": 72.42482405630199,
                "left": 73.8408775858392,
                "width": 24.067071870334825,
                "height": 21.049264235444657
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/590282_1604491059.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_Q3OqMup_GH2x4Xs.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 4,
          "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/pages/page_4_RClMbDc.jpg",
          "products": [
            {
              "item_id": "237598",
              "field1": "ALBERO DI NATALE IN LEGNO",
              "field2": "CON 20 LED ",
              "field3": "DIMENSIONI: DIAM 19X36H CM           ",
              "field4": "ASSORTITO IN 2 COLORI ",
              "description": "ALBERO DI NATALE IN LEGNO CON 20 LED  DIMENSIONI: DIAM 19X36H CM            ASSORTITO IN 2 COLORI ",
              "grammage": null,
              "price": "9.85",
              "price_label": "€ 9,85",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Alberi di Natale",
              "blueprint": {
                "top": 8.29899664870942,
                "left": 2.337545318831308,
                "width": 23.48560460652591,
                "height": 18.526766779356592
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/65596_1604339600.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_i8PCfWe_F765g2d.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "237366",
              "field1": "PISTA CON TRENO ",
              "field2": "PER ALBERO DI NATALE",
              "field3": "DIMENISONI: DIAM 89 CM          ",
              "field4": "",
              "description": "PISTA CON TRENO  PER ALBERO DI NATALE DIMENISONI: DIAM 89 CM          ",
              "grammage": null,
              "price": "29.95",
              "price_label": "€ 29,95",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Accessori",
              "blueprint": {
                "top": 8.29899664870942,
                "left": 26.275538494348474,
                "width": 23.83423970995948,
                "height": 18.526766779356592
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/298624_1604313325.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_jUAGWAV_JOmRfMg.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "info",
                  "title": "",
                  "data": {
                    "titolo": "Pista con treno",
                    "testo": "Pista con treno -Da montare su Albero di Natale -Dimensioni: diam 89cm.",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/UddhfhZpvX/images/1_b5XcH5Q.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "237651",
              "field1": "VILLAGGIO NATALIZIO CON GIOSTRA ",
              "field2": "LUCI E MOVIMENTO",
              "field3": "ASSORTITO IN 2 MODELLI ",
              "field4": "",
              "description": "VILLAGGIO NATALIZIO CON GIOSTRA  LUCI E MOVIMENTO ASSORTITO IN 2 MODELLI ",
              "grammage": null,
              "price": "36.90",
              "price_label": "€ 36,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Accessori",
              "blueprint": {
                "top": 8.29899664870942,
                "left": 50.10977820430796,
                "width": 24.11894860311367,
                "height": 18.526766779356592
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/680017_1604400848.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_y9YjcFi_0C3eDhk.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "238120",
              "field1": "ALBERO DI NATALE INNEVATO SLIM   ",
              "field2": "DISPONIBILI: H 180,210 CM ",
              "field3": "",
              "field4": "",
              "description": "ALBERO DI NATALE INNEVATO SLIM    DISPONIBILI: H 180,210 CM ",
              "grammage": null,
              "price": "94.90",
              "price_label": "€ 94,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Alberi di Natale",
              "blueprint": {
                "top": 8.29899664870942,
                "left": 74.22872680742162,
                "width": 23.562806568564724,
                "height": 18.526766779356592
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/slim_1604683519.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_yECkXeJ_kZ4zcOk.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "237450",
              "field1": "DECORO NATALIZIO PER ALBERO ",
              "field2": "MOD. PATTINI",
              "field3": "ASSORTITO IN 3 COLORI",
              "field4": "",
              "description": "DECORO NATALIZIO PER ALBERO  MOD. PATTINI ASSORTITO IN 3 COLORI",
              "grammage": null,
              "price": "1.99",
              "price_label": "€ 1,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Decorazioni",
              "blueprint": {
                "top": 27.191298784388994,
                "left": 2.453961399018982,
                "width": 23.43372787374707,
                "height": 18.490083173384516
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/651886_1604317339.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_2OU4oGG_7fCGg49.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "237429",
              "field1": "DECORAZIONE IN VETRO PER ALBERO",
              "field2": "MODELLO: BABBO E PINGUINO",
              "field3": "",
              "field4": "",
              "description": "DECORAZIONE IN VETRO PER ALBERO MODELLO: BABBO E PINGUINO",
              "grammage": null,
              "price": "3.25",
              "price_label": "€ 3,25",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Decorazioni",
              "blueprint": {
                "top": 27.191298784388994,
                "left": 26.249600127959056,
                "width": 23.52420558754532,
                "height": 18.490083173384516
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/681194_1604316097.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_KAGPAHA_fScvsij.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "237763",
              "field1": "BIGLIETTO PER LETTERINA DI NATALE ",
              "field2": "DIMENSIONI: CM 13,5X21H   ",
              "field3": "ASSORTITA IN DIVERSI MODELLI",
              "field4": "",
              "description": "BIGLIETTO PER LETTERINA DI NATALE  DIMENSIONI: CM 13,5X21H    ASSORTITA IN DIVERSI MODELLI",
              "grammage": null,
              "price": "0.95",
              "price_label": "€ 0,95",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Accessori",
              "blueprint": {
                "top": 27.191298784388994,
                "left": 50.22619428449563,
                "width": 23.43372787374707,
                "height": 18.490083173384516
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/64270b_1604512578.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_niLYgLP_GZPofeZ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "237575",
              "field1": "CASSETTA PORTA LETTERE BABBO NATALE",
              "field2": "COLORE ROSSO",
              "field3": "DIMENSIONI: CM 18X16X27H",
              "field4": "",
              "description": "CASSETTA PORTA LETTERE BABBO NATALE COLORE ROSSO DIMENSIONI: CM 18X16X27H",
              "grammage": null,
              "price": "28.90",
              "price_label": "€ 28,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Accessori",
              "blueprint": {
                "top": 27.191298784388994,
                "left": 74.02183301343571,
                "width": 23.705161015141822,
                "height": 18.490083173384516
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/0971078_1604339336.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_CqaK0ew_Sn9Q7WB.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "238215",
              "field1": "RENNA NATALIZIA IN TESSUTO",
              "field2": "DIMENSIONI: CM 25X15X50H    ",
              "field3": "ASSORTITA IN 2 COLORI    ",
              "field4": "",
              "description": "RENNA NATALIZIA IN TESSUTO DIMENSIONI: CM 25X15X50H     ASSORTITA IN 2 COLORI    ",
              "grammage": null,
              "price": "11.95",
              "price_label": "€ 11,95",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Grigio",
                "Beige"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Decorazioni",
              "blueprint": {
                "top": 46.00127959053103,
                "left": 2.3634836852207304,
                "width": 23.34325015994881,
                "height": 18.36212412028151
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/62081a_1604746487.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_9Ta3ZnW_ffQvZog.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "238122",
              "field1": "GIOSTRA RUOTA PANORAMICA NATALIZIA",
              "field2": "CON LUCI E MOVIMENTO",
              "field3": "",
              "field4": "",
              "description": "GIOSTRA RUOTA PANORAMICA NATALIZIA CON LUCI E MOVIMENTO",
              "grammage": null,
              "price": "34.90",
              "price_label": "€ 34,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Accessori",
              "blueprint": {
                "top": 46.00127959053103,
                "left": 26.249600127959056,
                "width": 23.705161015141822,
                "height": 18.36212412028151
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/0973797_1604683785.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_GFUe7mV_3ma0P08.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "237361",
              "field1": "PUPAZZO DI NEVE ",
              "field2": "DIMENSIONI: CM 20X12X48H  ",
              "field3": "ASSORTITO IN 2 COLORI",
              "field4": "",
              "description": "PUPAZZO DI NEVE  DIMENSIONI: CM 20X12X48H   ASSORTITO IN 2 COLORI",
              "grammage": null,
              "price": "7.95",
              "price_label": "€ 7,95",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Rosso",
                "Grigio"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Decorazioni",
              "blueprint": {
                "top": 46.00127959053103,
                "left": 49.95476114310088,
                "width": 23.705161015141826,
                "height": 18.36212412028151
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/62090_1604313062.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_8DUiuGl_3P4tAuz.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "info",
                  "title": "",
                  "data": {
                    "titolo": "DEC NAT PUPAZZO NEVE",
                    "testo": "Decorazione natalizia in tessuto -Modello Pupazzo di neve -Dimensioni: cm 20x12x48G -Assortito in 2 colori.",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/UddhfhZpvX/images/1_aQahnbX.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "237716",
              "field1": "BIMBO NATALIZIO IN MAGNESIA",
              "field2": "CON LANTERNA E CON LIBRO",
              "field3": "DIMENSIONI: CM 40H",
              "field4": "",
              "description": "BIMBO NATALIZIO IN MAGNESIA CON LANTERNA E CON LIBRO DIMENSIONI: CM 40H",
              "grammage": null,
              "price": "22.50",
              "price_label": "€ 22,50",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Accessori",
              "blueprint": {
                "top": 46.00127959053103,
                "left": 73.93135529963745,
                "width": 23.89717956920452,
                "height": 18.36212412028151
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/62003_1604422135.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_bn4h0yl_K7bq9xt.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "237750",
              "field1": "LUCI DECORATIVE A BATTERIA ",
              "field2": "MOD. STELLE",
              "field3": "DIMENSIONI:  2 MT",
              "field4": "",
              "description": "LUCI DECORATIVE A BATTERIA  MOD. STELLE DIMENSIONI:  2 MT",
              "grammage": null,
              "price": "6.70",
              "price_label": "€ 6,70",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Illuminazione",
              "blueprint": {
                "top": 65.00319897632757,
                "left": 2.453961399018982,
                "width": 23.52420558754532,
                "height": 18.298144593730004
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/STAR_1604510804.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_hY57jHC_ncdFieY.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "238213",
              "field1": "NATIVITÀ COMPOSTA DA 10 PEZZI",
              "field2": "DIMENSIONI: CM 10H   ",
              "field3": "",
              "field4": "",
              "description": "NATIVITÀ COMPOSTA DA 10 PEZZI DIMENSIONI: CM 10H   ",
              "grammage": null,
              "price": "7.50",
              "price_label": "€ 7,50",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Natività",
              "blueprint": {
                "top": 65.00319897632757,
                "left": 26.159122414160805,
                "width": 23.705161015141822,
                "height": 18.298144593730004
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/981376_1604746122.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_XKcDTYt_v62BxZg.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "237721",
              "field1": "CAPANNA PER PRESEPE",
              "field2": "CON PORTA E SCALE",
              "field3": "DIMENSIONI: CM 50X23X31H     ",
              "field4": "",
              "description": "CAPANNA PER PRESEPE CON PORTA E SCALE DIMENSIONI: CM 50X23X31H     ",
              "grammage": null,
              "price": "26.90",
              "price_label": "€ 26,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Natività",
              "blueprint": {
                "top": 65.00319897632757,
                "left": 50.045238856899125,
                "width": 23.705161015141822,
                "height": 18.298144593730004
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/669548_1604425243.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_AD7IykG_xtPGZ3N.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "197017",
              "field1": "PRESEPE CON PAESAGGIO",
              "field2": "E LUCI",
              "field3": "CM 45X30X38H",
              "field4": "",
              "description": "PRESEPE CON PAESAGGIO E LUCI CM 45X30X38H",
              "grammage": null,
              "price": "59.90",
              "price_label": "€ 59,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": 0,
              "max_purchasable_pieces": 0,
              "points": "0",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Addobbi",
              "subcategory": "Accessori",
              "blueprint": {
                "top": 65.00319897632757,
                "left": 73.8408775858392,
                "width": 23.976594156536574,
                "height": 18.298144593730004
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/671733_1573147400.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/products/cropped_image_2sAvWWq_ByxGAAg.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 5,
          "image_file": "https://interattivo.s3.amazonaws.com/UddhfhZpvX/pages/fine_procasa_iUj625v.png",
          "products": []
        }
      ]
    }
  }

}

const lefletSwitch = () => {
  return leaflets.procasa;
}

export const serverResponse = lefletSwitch(); 